import React from 'react';

import Process from '../Process';

import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import { trigger } from 'swr';

const specialists = {
  content_writer: {
    icon: '/images/icons/specialists/content_writer.svg',
    title: (
      <>
        Content<br></br>Writer
      </>
    ),
    text: 'This specialist writes the captions of the posts and defines the tone of the voice of the social media platforms. ',
  },
  social_media_advertiser: {
    icon: '/images/icons/specialists/social_media_advertiser.svg',
    title: (
      <>
        Social media<br></br>advertiser
      </>
    ),
    text: 'This specialist creates an advertising strategy, performs A/B testing, runs and optimizes all the ads.',
  },
  digital_analyst: {
    icon: '/images/icons/specialists/digital_analyst.svg',
    title: (
      <>
        Digital<br></br>Analyst
      </>
    ),
    text: 'This specialist studies and analyzes the results, and based on them suggests some optimizations.',
  },
  digital_creative_specialist: {
    icon: '/images/icons/specialists/digital_analyst.svg',
    title: (
      <>
        Digital Creative <br></br>Analyst
      </>
    ),
    text: 'This specialist is responsible for the creative content creation so that the Instagram posts have a unique message, as well as include the latest market trends.',
  },
  account_manager: {
    icon: '/images/icons/specialists/account_manager.svg',
    title: (
      <>
        Account<br></br>manager
      </>
    ),
    text: 'This specialist carries all the communication and keeps you updated from the very beginning until the end.',
  },
  digital_strategist: {
    icon: '/images/icons/specialists/digital_strategist.svg',
    title: (
      <>
        Digital<br></br>Strategist
      </>
    ),
    text: 'This specialist provides a one-month strategy to achieve business goals across different platforms.',
  },
  smm_specialist: {
    icon: '/images/icons/specialists/facebook_marketing_specialist.svg',
    title: <>SMM Specialist</>,
    text: 'FB Blueprint Certified specialist manages all your SM pages & generates content ideas, publishes the posts and communicates with your audience.',
  },
  designer: {
    icon: '/images/icons/specialists/designer.svg',
    title: 'Designer',
    text: 'This specialist creates all the social media visuals in accordance with the brand image and predefined content.',
  },
  videgrapher: {
    icon: '/images/icons/specialists/videographer.svg',
    title: 'Videographer',
    text: 'This specialist creates 15-second eye-catching and effective videos based on the previously defined content.',
  },
  creative_director: {
    icon: '/images/icons/specialists/videographer.svg',
    title: 'Creative Director',
    text: 'This specialist determines the creative vision of a brand or project and manifests that vision through digital.',
  },
};

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="cursor-pointer absolute" style={{ top: '50%', right: '-30px', transform: 'translateY(-50%)' }} onClick={onClick}>
      <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="cursor-pointer absolute -left-30" style={{ top: '50%', transform: 'translateY(-50%) scaleX(-1)' }} onClick={onClick}>
      <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
    </div>
  );
}

export default function SimpleSlider(props) {
  var settings = {
    infinite: true,
    speed: 400,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots: false,
    waitForAnimate: false,
    swipe: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          variableWidth: true,
          arrows: false,
          swipe: true,
        },
      },
    ],
    afterChange: function (a, b) {
      // if(a == 0){
      //   if(document.getElementById('arrow-prev-specialists')){
      //     document.getElementById('arrow-prev-specialists').style.display = 'none';
      //   }
      // }
      // else if(a == 4){
      //   if(document.getElementById('arrow-next-specialists')){
      //     document.getElementById('arrow-next-specialists').style.display = 'none';
      //   }
      // }else{
      //   if(document.getElementById('arrow-prev-specialists')){
      //     document.getElementById('arrow-prev-specialists').style.display = 'block';
      //   }
      //   if(document.getElementById('arrow-next-specialists')){
      //     document.getElementById('arrow-next-specialists').style.display = 'block';
      //   }
      // }
    },
  };
  return (
    <Slider {...settings} className="process-slider relative z-10">
      {props.specialists.map((specialist, index) => (
        <div key={index} className="max-w-230 pr-15 md:pr-0">
          <div className="flex flex-row items-center mb-15">
            <img src={specialists[specialist].icon} alt={specialist}></img>
            <p className="text-black font-bold ml-10 leading-5">{specialists[specialist].title}</p>
          </div>

          <p>{specialists[specialist].text}</p>
        </div>
      ))}
    </Slider>
  );
}
